// extracted by mini-css-extract-plugin
module.exports = {"progress":"CourseProgressSkeleton__progress__2mM1L","linesWrapper":"CourseProgressSkeleton__linesWrapper__2vgAj","line":"CourseProgressSkeleton__line__256vA"};